import { jsx as _jsx } from "react/jsx-runtime";
import { AdsProvider } from "@/ads/context";
import { brandConfiguration } from "@/brands/config";
import { CDP_INITIATIVE } from "@/constants";
import { CallTrackingProvider } from "@/contexts/callTracking";
import { CdpConfigProvider } from "@/contexts/cdpConfig";
import { ClassifiedProvider } from "@/contexts/classified";
import { ConfirmationPageProvider } from "@/contexts/confirmPage";
import { ContactProvider } from "@/contexts/contact";
import { RefsProvider } from "@/contexts/ref";
import { GalleryProvider } from "@/gallery/contexts";
import { BrandProvider } from "@/shared/contexts";
import { FavoritesProvider } from "@seeker-consumer-portal/favorite-heart";
import { MapProvider } from "@/domains/map";
import { ShouldStoreToSeenProvider } from "@/contexts/seen";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export let featureFlagsTracking;
export let featureFlags;
export let avClientType;
export const CdpProvider = ({ children, config, classified, error, }) => {
    var _a;
    const { env } = config || {};
    const locale = config === null || config === void 0 ? void 0 : config.locale;
    const brand = config === null || config === void 0 ? void 0 : config.brand;
    const { bWindow } = useBrowserAPI();
    // @ts-ignore
    featureFlagsTracking = classified === null || classified === void 0 ? void 0 : classified.featureFlagsTracking;
    // @ts-ignore
    featureFlags = classified === null || classified === void 0 ? void 0 : classified.featureFlags;
    bWindow["pageProps"] = { config, classified, error };
    // parse the abVariant from featureFlagsTracking as classified?.abVariant is only for BICLayout at this time
    // @ts-ignore
    const abVariant = (featureFlagsTracking === null || featureFlagsTracking === void 0 ? void 0 : featureFlagsTracking.toLowerCase().includes("_b"))
        ? "B"
        : "A";
    const shouldStoreToSeenInitial = (error === null || error === void 0 ? void 0 : error.code) == null;
    return (_jsx(CdpConfigProvider, { value: config, children: _jsx(ClassifiedProvider, { value: classified, children: _jsx(ShouldStoreToSeenProvider, { initial: shouldStoreToSeenInitial, children: _jsx(BrandProvider, { config: brandConfiguration, children: _jsx(ConfirmationPageProvider, { children: _jsx(ContactProvider, { crsBaseUrl: config.crsBaseUrl, contactSections: classified === null || classified === void 0 ? void 0 : classified.contactSections, children: _jsx(RefsProvider, { children: _jsx(CallTrackingProvider, { children: _jsx(FavoritesProvider, { env: env, 
                                        // @ts-ignore we need to update the FavoritesProvider to accept LOGICIMMO
                                        brand: brand, locale: locale, category: "classified_detail", initiative: CDP_INITIATIVE, children: _jsx(GalleryProvider, { children: _jsx(AdsProvider, { bffData: classified === null || classified === void 0 ? void 0 : classified.advertising, abVariant: abVariant, distributionType: (_a = classified === null || classified === void 0 ? void 0 : classified.rawData) === null || _a === void 0 ? void 0 : _a.distributionType, children: _jsx(MapProvider, { children: children }) }) }) }) }) }) }) }) }) }) }) }));
};
